/**
 * Author:王玉蓉;
 * CreateTime:2019-09-06 15:29;
 * Description:
 **/
import echarts from 'echarts'

export function showEcharts(id, type, data, yMax) {
  var myChart = echarts.init(document.getElementById(id));

  var colors = [
    "#00ffff",
    "#25559b",
    "#8a2cd6",
    "#1985e9",
    "#ec4675",
    "#26e6b9",
    "#762788"
  ];
  var option;
  if (type == 1) {
    option = {
      tooltip: {
        trigger: "axis"
      },
      calculable: true,
      color: colors,
      grid: {
        //其中(x,y)针对左上角图的位置调整，(x2,y2)针对左下角。
        y: 20,
        x2: 16,
        x: 80,
        y2: 20,
        borderWidth: 0 //此处去掉那个白色边框
      },
      xAxis: [
        {
          type: "category",
          boundaryGap: false,
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: "13"
            },
            interval: "auto"
            // rotate: 30,
          },
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            //y轴
            show: false
          },
          data: data.time
        }
      ],
      yAxis: [
        {
          type: "value",
          splitLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: "13"
            }
          },
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            //y轴
            show: false
          },
          min: 0,
          max: yMax
        }
      ],
      series: [
        {
          name: "",
          type: "line",
          smooth: true,
          itemStyle: {normal: {areaStyle: {type: "default"}}},
          data: data.value
        }
      ]
    };
  } else if (type == 2) {
    option = {
      tooltip: {
        trigger: "axis"
      },
      grid: {
        //其中(x,y)针对左上角图的位置调整，(x2,y2)针对左下角。
        y: 20,
        x2: 25,
        x: 45,
        y2: 20,
        borderWidth: 0 //此处去掉那个白色边框
      },
      calculable: true,
      color: colors,
      xAxis: [
        {
          type: "value",
          min: 0,
          // max: 3000,
          //interval:[0,500,50,100,500,5000],
          splitLine: {
            show: false
          },
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            //y轴
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: "13"
            }
          }
        }
      ],
      yAxis: [
        {
          type: "category",
          data: ["站点", "车辆", "人员"],
          nameGap: 1,
          nameRotate: -90,
          splitLine: {
            show: false
          },
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            //y轴
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: "13"
            }
          }
        }
      ],
      series: [
        /* {
          type: 'bar',
          name: '在线',
          barWidth: 10,
          data: [data.useGasTotalNum, data.drivingNum],
          label: {
            normal: {
              show: true,
              position: "insideLeft"
            }
          },
          itemStyle: {
            normal: {
              color: '#19be6b',
            },
          },
        }, */
        {
          type: "bar",
          name: "总数",
          barWidth: 10,
          label: {
            normal: {
              show: true,
              position: "insideLeft"
            }
          },
          itemStyle: {
            normal: {
              color: "#5cadff"
            }
          },
          data: [data.siteTotalNum, data.carTotalNum, data.accountNum]
        }
      ]
    };
  } else if (type == 3) {
    option = {
      tooltip: {
        trigger: "axis"
      },
      grid: {
        //其中(x,y)针对左上角图的位置调整，(x2,y2)针对左下角。
        y: 20,
        x2: 16,
        x: 80,
        y2: 20,
        borderWidth: 0 //此处去掉那个白色边框
      },
      calculable: true,
      color: colors,
      xAxis: [
        {
          type: "category",
          data: data.time,
          splitLine: {
            show: false
          },
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            //y轴
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: "13"
            },
            interval: "auto"
            // rotate: 40,
          }
        }
      ],
      yAxis: [
        {
          type: "value",
          splitLine: {
            show: false
          },
          axisTick: {
            //y轴刻度线
            show: false
          },
          axisLine: {
            //y轴
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: "13"
            }
          },
          min: 0,
          max: yMax
        }
      ],
      series: [
        {
          name: "",
          type: "bar",
          data: data.value,
          barWidth: 15,
          //barCategoryGap:15,
          /* markPoint : {
            data : [
              {type : 'max', name: '最大值'},
              {type : 'min', name: '最小值'}
            ]
          },
          markLine: {
            data: [{ type: "average", name: "平均值" }]
          },*/
          itemStyle: {
            normal: {
              //柱形图圆角，初始化效果
              barBorderRadius: [10, 10, 10, 10],
              color: function (params) {
                return colors[params.dataIndex];
                /*if(params.dataIndex % 2 == 0){
                  return colors[0]
                }else{
                  return colors[3]
                }*/
              }
            }
          }
        }
      ]
    };
  }
  myChart.setOption(option);
  myChart.resize();
}
